import { connect } from 'react-redux';

import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import pageContent from '../IFTPayments/iftPayments.content';
import LandingPage from '../../../sharedComponents/LandingPage/LandingPage';
import { canShowPaymentTabs, getAccountsWithIFTCapability } from '../../../states/accounts/selectors';
import { getInternationalPayees } from '../../../states/payees/selectors';
import { getTemplateListByType } from '../../../states/templates/selectors';
import { fetchTemplates, selectPaymentTemplate, editPaymentTemplate } from '../../../states/templates/actions';
import { TYPE_IFT } from '../../../config';
import { pages, goToPage, resetApp } from '../../../states/page/actions';
import { setSelectedFromAccount } from '../../../states/payeeSelector/actions';

const mapState = (state) => ({
	fromAccounts: getAccountsWithIFTCapability(state),
	toPayees: getInternationalPayees(state),
	templates: getTemplateListByType(state, TYPE_IFT),
	showPaymentTabs: canShowPaymentTabs(state),
});

const mapDispatch = (dispatch) => ({
	fetchTemplates: () => dispatch(fetchTemplates()),
	handleSelectTemplate: (id) => dispatch(selectPaymentTemplate(id)),
	handleEditTemplate: (id, name) => dispatch(editPaymentTemplate(id, name)),
	goToPayeeSelector: () => dispatch(goToPage(pages.IFTPayeeSelector)),
	setSelectedFromAccount: (fromAccount) => dispatch(setSelectedFromAccount(fromAccount)),
	reset: () => dispatch(resetApp),
});

export const connectWrapper = connect(mapState, mapDispatch)(LandingPage);
const contentWrapper = withContent({ content: pageContent });
export default withScrollTop(contentWrapper(connectWrapper));
